module.exports = __webpack_public_path__ + "img/6452c05.png";